// Comisiones de las OTAs (7-oct-2026). «Lo que te llega» en la ficha de la reserva
// (components/Reservas/PayData.vue): total − comisión de la OTA − IVA de la comisión.
// Placeholders: {channel} nombre del canal, {rate} y {vat} porcentajes ya formateados,
// {base} y {amount} importes ya formateados, {unit} tipo de habitación.
// Portugués de Brasil.
export const otaNet = {
  title: "O que chega até você",
  gross: "Total da reserva",
  grossOnChannel: "Total da reserva no {channel}",
  grossOfUnit: "Total de {unit}",
  commission: "Comissão e taxas do {channel} ({rate}%)",
  commissionOfBase: "Comissão e taxas do {channel} ({rate}% de {base})",
  commissionReal: "Comissão do {channel} (informada pelo canal)",
  vat: "Imposto sobre a comissão ({vat}%)",
  net: "Você recebe (aprox.)",
  howItWorks: "Como é calculado",
  infoEstimate: "Estimativa com as porcentagens de “Comissões das OTAs” da hospedagem. A OTA pode transferir um valor um pouco diferente (arredondamentos, promoções, taxas de pagamento).",
  infoBase: "A taxa turística e a caução não pagam comissão.",
  infoReal: "A comissão desta reserva foi informada por {channel}. O imposto sobre a comissão é uma estimativa com a porcentagem de “Comissões das OTAs”, então o que você recebe continua sendo aproximado.",
  infoRealNoVat: "A comissão desta reserva foi informada por {channel}. Mesmo assim, a transferência pode variar um pouco (arredondamentos, taxas de pagamento).",
  airbnbNet: "O Airbnb já paga o valor líquido: o que você vê é o que você recebe.",
  apart: "Não inclui {amount} que você cobra à parte: isso não passa pelo {channel}.",
  theChannel: "a OTA",
};
